import React from 'react';
import Button from '../../../components/ui/Button';

const QuickActions = () => {
  const actions = [
    {
      id: 1,
      title: 'Générer un lien d\'affiliation',
      description: 'Créez un nouveau lien de suivi personnalisé',
      icon: 'Link',
      variant: 'default',
      action: () => console.log('Generate affiliate link')
    },
    {
      id: 2,
      title: 'Matériel marketing',
      description: 'Accédez aux bannières et ressources',
      icon: 'Image',
      variant: 'outline',
      action: () => console.log('Access marketing materials')
    },
    {
      id: 3,
      title: 'Créer une campagne',
      description: 'Lancez une nouvelle campagne promotionnelle',
      icon: 'Plus',
      variant: 'outline',
      action: () => console.log('Create campaign')
    },
    {
      id: 4,
      title: 'Voir les rapports',
      description: 'Consultez vos statistiques détaillées',
      icon: 'BarChart3',
      variant: 'ghost',
      action: () => console.log('View reports')
    }
  ];

  return (
    <div className="bg-card rounded-lg border border-border p-6 shadow-sm">
      <h3 className="text-lg font-semibold text-card-foreground mb-4">Actions rapides</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {actions?.map((action) => (
          <div
            key={action?.id}
            className="p-4 border border-border rounded-lg hover:bg-muted/50 transition-colors duration-150 cursor-pointer group"
            onClick={action?.action}
          >
            <div className="flex items-start space-x-3">
              <div className="flex items-center justify-center w-10 h-10 bg-accent/10 rounded-lg group-hover:bg-accent/20 transition-colors duration-150">
                <Button
                  variant="ghost"
                  size="icon"
                  iconName={action?.icon}
                  iconSize={20}
                  className="text-accent hover:text-accent"
                />
              </div>
              <div className="flex-1">
                <h4 className="text-sm font-medium text-card-foreground group-hover:text-accent transition-colors duration-150">
                  {action?.title}
                </h4>
                <p className="text-xs text-muted-foreground mt-1">
                  {action?.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 pt-4 border-t border-border">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <Button
            variant="default"
            size="sm"
            iconName="MessageSquare"
            iconPosition="left"
            iconSize={16}
            onClick={() => console.log('Open messaging')}
          >
            Centre de messages
          </Button>
          <Button
            variant="outline"
            size="sm"
            iconName="HelpCircle"
            iconPosition="left"
            iconSize={16}
            onClick={() => console.log('Open help center')}
          >
            Centre d'aide
          </Button>
        </div>
      </div>
    </div>
  );
};

export default QuickActions;